/* ═══════════════════════════════════════
   HRC — MARQUEE
═══════════════════════════════════════ */

(function () {
  document.querySelectorAll(".hrc-mq").forEach(function (mq) {
    var track = mq.querySelector("[data-mq-track]");
    var pauseOnHover = mq.dataset.pauseHover === "true";
    if (!track) return;

    /* ── Hover pause ── */
    if (pauseOnHover) {
      mq.addEventListener("mouseenter", function () {
        track.style.animationPlayState = "paused";
      });
      mq.addEventListener("mouseleave", function () {
        track.style.animationPlayState = "running";
      });
    }

    /* ── Touch pause ── */
    var touchTimer;
    mq.addEventListener(
      "touchstart",
      function () {
        track.style.animationPlayState = "paused";
        clearTimeout(touchTimer);
        touchTimer = setTimeout(function () {
          track.style.animationPlayState = "running";
        }, 2000);
      },
      { passive: true },
    );

    /* ── Reduced motion ── */
    var motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    function applyMotion() {
      track.style.animationPlayState = motionQuery.matches
        ? "paused"
        : "running";
    }
    applyMotion();
    motionQuery.addEventListener("change", applyMotion);
  });
})();
